import type { AppLang, I18nConstants } from './i18n.factory';

export async function createI18nAsync(lang: AppLang): Promise<I18nConstants> {
  const factoryPromise = import('./i18n.factory');

  switch (lang) {
    case 'en': {
      const [{ createI18nConstants }, { en }, { he }] = await Promise.all([
        factoryPromise,
        import('./en'),
        import('./he'),
      ]);
      return createI18nConstants(en, he);
    }
    case 'fr': {
      const [{ createI18nConstants }, { fr }, { he }] = await Promise.all([
        factoryPromise,
        import('./fr'),
        import('./he'),
      ]);
      return createI18nConstants(fr as any, he);
    }
    case 'ru': {
      const [{ createI18nConstants }, { ru }, { he }] = await Promise.all([
        factoryPromise,
        import('./ru'),
        import('./he'),
      ]);
      return createI18nConstants(ru as any, he);
    }
    case 'he':
    default: {
      const [{ createI18nConstants }, { he }] = await Promise.all([
        factoryPromise,
        import('./he'),
      ]);
      return createI18nConstants(he);
    }
  }
}
